import React, { useState, useEffect } from 'react';
import './HotelInformation.css';

const HotelInformation = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [hotelImages, setHotelImages] = useState([]);
  
  useEffect(() => {
    // Fetch the list of images from a JSON file
    fetch('/images/hotel/images.json')
      .then(response => response.json())
      .then(data => setHotelImages(data.images))
      .catch(error => {
        console.error("Error loading images:", error);
        // Fallback to hardcoded list
        const fallbackImages = [
          '/images/hotel/hotel-exterior.jpg',
          '/images/hotel/hotel-lobby.jpg',
          '/images/hotel/hotel-pool.jpg',
          '/images/hotel/hotel-beach.jpg',
          '/images/hotel/hotel-restaurant.jpg',
          '/images/hotel/hotel-room.jpg',
          '/images/hotel/hotel-spa.jpg',
        ];
        setHotelImages(fallbackImages);
      });
  }, []);

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === hotelImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? hotelImages.length - 1 : prevIndex - 1
    );
  };

  const goToImage = (index) => {
    setCurrentImageIndex(index);
  };

  return (
    <div className="page-container hotel-info-container">
      <h1>Hotel Information</h1>
      
      {/* Image Carousel */}
      <div className="hotel-carousel">
        <div className="carousel-container">
          {hotelImages.length > 0 && (
            <>
              <div className="carousel-image-container">
                <img 
                  src={hotelImages[currentImageIndex]} 
                  alt={`AVA Resort Cancun - View ${currentImageIndex + 1}`} 
                  className="carousel-image"
                />
              </div>
              
              <button className="carousel-button prev" onClick={prevImage} aria-label="Previous image">
                &#10094;
              </button>
              <button className="carousel-button next" onClick={nextImage} aria-label="Next image">
                &#10095;
              </button>
              
              <div className="carousel-dots">
                {hotelImages.map((_, index) => (
                  <span 
                    key={index} 
                    className={`carousel-dot ${index === currentImageIndex ? 'active' : ''}`}
                    onClick={() => goToImage(index)}
                    aria-label={`Go to image ${index + 1}`}
                  ></span>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
      
      <div className="main-hotel">
        <div className="hotel-details">
          <h2>AVA Resort Cancun</h2>
          <p className="hotel-tagline">Our wedding venue and <b>required accommodation</b></p>
          <div className="hotel-info-block">
            <h3 style={{color: 'red', fontWeight: '600', }}>Note: All guests must book their stay through the link below.</h3>
          </div>
          <div className="hotel-info-block">
            <h3>About the Resort</h3>
            <p>
              Newly built, the AVA Resort Cancun is an expansive, enriching resort oasis that opens the door to a universe of experiences, events, programming, and amenities. Guests of all ages can trust that this resort will be constantly dreaming up new ideas to make every stay unique, restorative, and full of fun, no matter how many times you visit!
            </p>
            <p>
              AVA Resort Cancun sets a higher new standard of luxury all inclusive. Every luxurious room at AVA looks out onto the translucent crystal waters of the Caribbean. The resort boasts elevated all inclusive dining with a collection of over 17 restaurants and bars designed exclusively for AVA.
            </p>
          </div>
          
          <div className="hotel-info-block">
            <h3>Room Block Information</h3>
            <p>
              We have reserved a block of rooms at a special rate for our wedding guests. 
              To book within our room block, please use the booking link below.
            </p>
            <p>
              <strong>Booking Deadline:</strong> June 20, 2025 (confirm your stay with a $200 nonrefundable deposit)
            </p>
            <p>
              <strong>Final Payment Deadline:</strong> November 4, 2025 (to be automatically charged to the credit card used at the time of booking)
            </p>
          </div>
          
          <div className="booking-button">
            <a href="https://www.reservhotel.com/cancun-mexico/ava-resort-cancun/booking-engine/ibe5.main?hotel=10915&source=TH&AFF=18944&agent=19491&groupid=IWAliAli&showmon=01-Dec-25#" target="_blank" rel="noopener noreferrer">Book Your Stay</a>
          </div>
        </div>
      </div>
      
      <div className="room-options">
        <h2>Room Options</h2>
        
        <div className="room-card">
          <h3>Ocean Front King - All Inclusive Meal Plan</h3>
          <div className="room-details">
            <div className="room-info">
              <p><strong>Bedding:</strong> 1 king sized bed & 1 sofa bed</p>
              <p><strong>Maximum Occupancy:</strong> maximum 2 adults OR 2 adults + 2 children (ages 0-12) OR 2 adults + 1 teen (ages 13-17)</p>
              <p><strong>Room Amenities:</strong> terrace with whirlpool tub, air conditioning, TV, Alarm Clock, In-Room Safe, Iron, Mini-Bar, Nespresso Machine, Bathrobe</p>
            </div>
            <div className="room-rates">
              <h4>Rates (includes all taxes and fees)</h4>
              <ul>
                <li><strong>Single Occupancy:</strong> $531 per adult / night</li>
                <li><strong>Double Occupancy:</strong> $265.50 per adult / night</li>
                <li><strong>Triple Occupancy:</strong> not permitted</li>
                <li><strong>Child (0-12 years):</strong> $0 per child / night when sharing with 2 adults</li>
                <li><strong>Teen (13-17 years):</strong> $99 per teen / night when sharing with 2 adults</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="room-card">
          <h3>Ocean Front Queen - All Inclusive Meal Plan</h3>
          <div className="room-details">
            <div className="room-info">
              <p><strong>Bedding:</strong> 2 queen sized beds</p>
              <p><strong>Maximum Occupancy:</strong> maximum 3 adults OR 3 adults + 1 child/teen (ages 0-17) OR 2 adults + 2 children/teens (ages 0-17)</p>
              <p><strong>Room Amenities:</strong> terrace with whirlpool tub, air conditioning, TV, Alarm Clock, In-Room Safe, Iron, Mini-Bar, Nespresso Machine, Bathrobe</p>
            </div>
            <div className="room-rates">
              <h4>Rates (includes all taxes and fees)</h4>
              <ul>
                <li><strong>Single Occupancy:</strong> $551 per adult / night</li>
                <li><strong>Double Occupancy:</strong> $275.50 per adult / night</li>
                <li><strong>Triple Occupancy:</strong> $217 per adult / night</li>
                <li><strong>Child (0-12 years):</strong> $0 per child / night when sharing with 2 adults</li>
                <li><strong>Teen (13-17 years):</strong> $99 per teen / night when sharing with 2 adults</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <div className="resort-amenities">
        <h2>Resort Amenities</h2>
        <ul className="amenities-list">
          <li>17 dining options including cafes, snacks bars and restaurants</li>
          <li>5 bars</li>
          <li>6 pools including kids pool</li>
          <li>Non-motorized water sports</li>
          <li>Arcade, bowling and pickleball courts</li>
          <li>Kids Club & Teens Club</li>
          <li>Daily and nightly entertainment</li>
          <li>Fitness center</li>
          <li>Beauty salon</li>
          <li>Gift shops and boutiques</li>
          <li>Laundry services</li>
        </ul>
      </div>
      
      <div className="cancellation-policy">
        <h2>Change & Cancellation Terms</h2>
        <ul>
          <li>Cancellations received before October 04, 2025 have no penalty. 91 days or more prior to scheduled arrival no penalties applicable.</li>
          <li>Cancellations on or after October 05, 2025 will incur $200 penalty. Between 90-61 days prior to scheduled arrival, deposit is non refundable.</li>
          <li>Cancellations on or after November 04, 2025 will incur $200 penalty. Between 60-31 days prior to scheduled arrival, deposit is non refundable.</li>
          <li>Cancellations on or after November 05, 2025 will incur 100% penalty. Between 30-0 days prior to scheduled arrival, 100% of the total room revenue will be assessed.</li>
        </ul>
      </div>
      
      <div className="transportation-info">
        <h2>Airport Transportation</h2>
        <p>
          Compliments of the ALI Families, roundtrip airport transfers will be arranged for all guests.
          Please submit your flight details no later than NOVEMBER 01, 2025 by way of the following link or forward your flight itinerary to reservations@lescape.com.
        </p>
        <div className="transport-button">
          <a href="https://form.jotform.com/250556148860966" target="_blank" rel="noopener noreferrer">Submit Flight Information</a>
        </div>
      </div>
    </div>
  );
};

export default HotelInformation; 